import { Button, Dropdown, Space, message } from 'antd'
import { KeyOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

export default function UserMenu() {
  const { status, user, logout } = useAuth()
  const navigate = useNavigate()

  if (status === 'loading') return null

  if (status === 'unauthenticated') {
    return (
      <Space size={8}>
        <Link to="/login">
          <Button type="text" size="small">登录</Button>
        </Link>
        <Link to="/register">
          <Button type="primary" size="small">注册</Button>
        </Link>
      </Space>
    )
  }

  const handleLogout = async () => {
    await logout()
    message.success('已退出登录')
    navigate('/login', { replace: true })
  }

  return (
    <Dropdown
      menu={{
        items: [
          { key: 'api-keys', icon: <KeyOutlined />, label: 'API Key 管理', onClick: () => navigate('/api-keys') },
          { type: 'divider' as const },
          { key: 'logout', icon: <LogoutOutlined />, label: '退出登录', onClick: handleLogout },
        ],
      }}
      placement="bottomRight"
    >
      <Button type="text" icon={<UserOutlined />} size="small">
        {user?.username ?? '用户'}
      </Button>
    </Dropdown>
  )
}
